import { useEffect, useState } from "react";
import { blockchainService } from "../../../../../services/blockchainService";
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";
import ConfirmarEtapaButton from "./ConfirmarEtapaButton";

/* Upload reutilizado */
import { FileUploadComponentPDF } from "../../Actions/FileUploadComponentPDF";
import { useSelectFile } from "../../Actions/FileUploadComponentPDF";
import { useEnviarFile } from "../../Actions/EnviarFile";
import FUSalvarButton from "../../FUSalvarButton";
import FUDeleteButton from "../../FUDeleteButton";
import { mostrarLogs } from "../../Actions/MostrarLogs";
import { cancelarFile } from "../../Actions/CancelarFile";
import { useConfirmacaoDocumentos } from "./useConfirmacaoDocumentos";


/* Styles */
import {
  DocumentsContainer,
  DocumentItem,
  DocumentLink,
  DocumentLinkContainer,
  StyledButtonLogs,
  StyledButtonCancelar,
  StyledButtonDownload,
} from "./TopicDocuments.styles";

export default function TopicDocuments({
  documentModel,
  topico,
  projectId,
  headers,
  onConfirmarTopico,
  onLoadQuestoes,
}) {
  const [data, setData] = useState({ questoes: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  /* 🔥 Upload por item */
  const [fileStates, setFileStates] = useState({});
  const [botaoSalvarAtivo, setBotaoSalvarAtivo] = useState(null);


  const questoes = Array.isArray(data.questoes) ? data.questoes : [];

  const {
    podeConfirmar,
    docsJaConfirmados,
    setDocsJaConfirmados,
  } = useConfirmacaoDocumentos({
    topico,
    questoes,
  });



  const { handleSelectFile } = useSelectFile({
    uuidv4,
    setFileStates,
    project_id: projectId,
    tela_name: documentModel?.nome,
    fileStates,
  });

  const { enviarFile } = useEnviarFile();


  const handleConfirmacaoDocumentos = async () => {
    await blockchainService.updateFileManagerControls(
      projectId,
      topico.id,
      headers
    );

    // UX imediata → some o botão
    setDocsJaConfirmados(true);

    await reloadTopic();
    // 🔁 AVISA O PAI PARA RECARREGAR O MODELO
    if (onConfirmarTopico) {
      await onConfirmarTopico();
    }
  };

  async function reloadTopic() {
    const response = await blockchainService.getTopicItems(
      documentModel.id,
      topico.id,
      projectId,
      headers
    );

    setData(response.topico);
  }

  async function abrirDocumento(documentPath) {
    try {
      const token = sessionStorage.getItem("Authorization");

      const fileData = await blockchainService.downloadDocument(
        documentPath,
        { Authorization: `Bearer ${token}` }
      );

      const fileURL = URL.createObjectURL(
        new Blob([fileData], { type: "application/pdf" })
      );

      const novaJanela = window.open();
      if (novaJanela) {
        novaJanela.document.write(`
          <iframe src="${fileURL}" width="100%" height="100%" style="border:none"></iframe>
        `);
      }
    } catch (error) {
      console.error("Erro ao abrir documento:", error);
    }
  }

  /* =========================
     Carregar documentos
  ========================== */
  useEffect(() => {
    async function loadDocuments() {
      try {
        setLoading(true);
        const response = await blockchainService.getTopicItems(
          documentModel.id,
          topico.id,
          projectId,
          headers
        );

        setData(response.topico);
        if (onLoadQuestoes) {
          onLoadQuestoes(response.topico.questoes);
        }
      } catch (err) {
        console.error("Erro ao carregar documentos:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    }

    if (documentModel && topico && projectId) {
      loadDocuments();
    }
  }, [documentModel, topico, projectId, headers]);

  if (loading || error) return null;



  return (
    <DocumentsContainer>
      {questoes.map((item) => (
        <DocumentItem key={item.modelo_item_id}>
          <strong>{item.questao}</strong> — {item.label}

          {/* Documento existente */}
          {item.document_path && item.document_ativo !== false && !item.document_data_hora_cancel && (
            <DocumentLink onClick={() => abrirDocumento(item.document_path)}>
              <DocumentLinkContainer>
                📄 {item.document_name}
              </DocumentLinkContainer>
            </DocumentLink>
          )}




          {/* Upload */}
          <div style={{ marginTop: 6, display: "flex", gap: 8, alignItems: "center" }}>
            {item.file_manager_control?.visible_upload && (
              <FileUploadComponentPDF
                item={item}
                handleFileChange={(e) =>
                  handleSelectFile(e, String(item.modelo_item_id), item.modelo_item_id)
                }
              />
            )}



            {/* 🔥 Botões SOMENTE do item ativo */}
            {fileStates[item.modelo_item_id] && (
              <>
                <FUSalvarButton
                  nome_arquivo={
                    fileStates[item.modelo_item_id].name_orig_ext ||
                    fileStates[item.modelo_item_id].fileName ||
                    'documento.pdf'
                  }
                  disabled={botaoSalvarAtivo === item.modelo_item_id}
                  handleUpload={async () => {
                    setBotaoSalvarAtivo(item.modelo_item_id);

                    try {
                      await enviarFile(
                        fileStates[item.modelo_item_id],
                        String(item.modelo_item_id),
                        fileStates
                      );

                      await reloadTopic();

                      setFileStates((prev) => {
                        const novo = { ...prev };
                        delete novo[item.modelo_item_id];
                        return novo;
                      });
                    } finally {
                      setBotaoSalvarAtivo(null);
                    }
                  }}
                />

                <FUDeleteButton
                  nome_arquivo={fileStates[item.modelo_item_id].fileName}
                  switchField={() =>
                    setFileStates((prev) => {
                      const novo = { ...prev };
                      delete novo[item.modelo_item_id];
                      return novo;
                    })
                  }
                />
              </>
            )}

            {/* Logs */}
            {item.file_manager_control?.visible_logs && item.log?.length > 0 && (
              <StyledButtonLogs onClick={() => mostrarLogs(item.log)}>
                Logs
              </StyledButtonLogs>
            )}

            {/* Cancelar */}
            {item.file_manager_control?.visible_cancel && item.document_name && (
              <StyledButtonCancelar
                disabled={!item.document_ativo}
                onClick={() =>
                  cancelarFile(
                    item.document_guid,
                    item.file_manager_nft_dt,
                    item.file_manager_control.visible_show_nft,
                    item.file_manager_control.file_manager_control_id,
                    headers,
                    item.contract_contract_address_client,
                    item.contract_wallet_owner,
                    documentModel.id,
                    projectId,
                    setData,
                    setFileStates,
                    setBotaoSalvarAtivo
                  )
                }
              >
                Cancelar
              </StyledButtonCancelar>
            )}

            {/* Download */}
            {item.file_manager_control?.visible_download && item.document_name && (
              <StyledButtonDownload
                disabled={!item.document_ativo}
                onClick={() =>
                  blockchainService.downloadDocumento(
                    item.document_guid,
                    item.document_ext,
                    item.document_name,
                    projectId,
                    documentModel?.nome,
                    headers,
                    item.document_path
                  )
                }
              >
                Download
              </StyledButtonDownload>
            )}
          </div>
        </DocumentItem>
      ))}
      <ConfirmarEtapaButton
        podeConfirmar={podeConfirmar}
        onConfirmar={handleConfirmacaoDocumentos}
      />

    </DocumentsContainer>
  );
}
